var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"UnderlinedHeading uppercase font-bold pb-2 mb-4 relative",class:[
    _vm.data.class,
    _vm.data.staticClass
  ]},[_vm._t("default"),_c('div',{staticClass:"UnderlinedHeading__underline absolute pin-l w-10 h-1 pin-b",class:[("bg-" + (_vm.props.color))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }